export default {
    az: (a, b) => a.name.localeCompare(b.name),
    za: (a, b) => b.name.localeCompare(a.name),
    "09": (a, b) => a.count - b.count,
    90: (a, b) => b.count - a.count,
};
